export default "__VITE_ASSET__BCz0Tog2__"